import { render, staticRenderFns } from "./allocateServices.vue?vue&type=template&id=6e585730"
import script from "./allocateServices.ts?vue&type=script&lang=js&external"
export * from "./allocateServices.ts?vue&type=script&lang=js&external"
import style0 from "./allocateServices.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports